<template>
  <p class="bottom-text" :class="isContactPanelActive ? 'fadeout-desktop' : 'fadein-desktop'">
    <span>The sensible study of production</span>
    <span>possibilities in the face of the modern</span>
    <span>world’s challenges.</span>
  </p>
</template>

<script>
export default {
  name: "BottomText",
  props: {
    isContactPanelActive: Boolean
  }
};
</script>

<style lang="scss">
.bottom-text {
  position: fixed;
  bottom: $screen-gutter-bottom - 7px;
  left: $screen-gutter-left + 32px;
  z-index: 10;

  span {
    display: block;
    line-height: 25px;
  }
}
</style>